import { CiStar } from "react-icons/ci";

export const TableEvaluationEndingPatient = ({ evaluations }) => {
  // Funciones ---------------------------------------------//
  const renderStars = (value) => {
    const stars = Array(5)
      .fill(0)
      .map((_, index) => (
        <CiStar
          key={index}
          className={index < value ? "text-warning" : "text-muted"}
          style={{ fontSize: "2rem" }}
        />
      ));
    return <div className="d-flex">{stars}</div>;
  };

  return (
    <div className="table-responsive shadow rounded">
      <table className="table table-center bg-white mb-0">
        <thead className="table-primary">
          <tr>
            <th className="border-bottom p-3">Preguntas</th>
            <th className="border-bottom p-3">Valoración</th>
          </tr>
        </thead>
        <tbody>
          {evaluations[0].questions.map((evaluation) => (
            <tr key={evaluation.id}>
              <td className="py-3">{evaluation.questionTitle}</td>
              <td className="py-3">{renderStars(Number(evaluation.value))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
